import { render, staticRenderFns } from "./PreDetail.vue?vue&type=template&id=4fc9abec&scoped=true"
import script from "./PreDetail.vue?vue&type=script&lang=js"
export * from "./PreDetail.vue?vue&type=script&lang=js"
import style0 from "./PreDetail.vue?vue&type=style&index=0&id=4fc9abec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc9abec",
  null
  
)

export default component.exports